import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
const PainSection = lazy(() => import('../components/sections/PainSection').then(m => ({
  default: m.PainSection
})));
const MechanismSection = lazy(() => import('../components/sections/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const ProductSection = lazy(() => import('../components/sections/ProductSection').then(m => ({
  default: m.ProductSection
})));
const PricingSection = lazy(() => import('../components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
const BenefitsSection = lazy(() => import('../components/sections/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const TestimonialsSection = lazy(() => import('../components/sections/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const UrgencySection = lazy(() => import('../components/sections/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const FinalCloseSection = lazy(() => import('../components/sections/FinalCloseSection').then(m => ({
  default: m.FinalCloseSection
})));
const FAQSection = lazy(() => import('../components/sections/FAQSection').then(m => ({
  default: m.FAQSection
})));
export function LandingPage() {
  return <div className="w-full min-h-screen bg-[#050810]" data-id="element-466">
      {/* Sticky top bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#050810]/90 backdrop-blur-md border-b border-[#252b45]/30" data-id="element-467">
        <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between" data-id="element-468">
          <span className="font-display text-sm md:text-base font-bold text-gold-gradient tracking-wide" data-id="element-469">
            SRME™
          </span>
          <a href="#precios" className="text-xs md:text-sm text-[#c9a84c] font-medium border border-[#c9a84c]/30 px-4 py-1.5 rounded-full
              hover:bg-[#c9a84c]/10 transition-colors duration-300
              focus:outline-none focus:ring-2 focus:ring-[#c9a84c]/50" data-id="element-470">
            Acceder ahora
          </a>
        </div>
      </div>

      <main data-id="element-471">
        <HeroSection data-id="element-472" />
        <Suspense fallback={<div className="min-h-[200px]" data-id="element-474" />} data-id="element-473">
          <PainSection data-id="element-475" />
          <MechanismSection data-id="element-476" />
          <ProductSection data-id="element-477" />
          <PricingSection data-id="element-478" />
          <BenefitsSection data-id="element-479" />
          <TestimonialsSection data-id="element-480" />
          <UrgencySection data-id="element-481" />
          <FinalCloseSection data-id="element-482" />
          <FAQSection data-id="element-483" />
        </Suspense>
      </main>

      {/* Footer */}
      <footer className="w-full border-t border-[#252b45]/30 bg-[#050810]" data-id="element-484">
        <div className="max-w-6xl mx-auto px-5 py-8 text-center" data-id="element-485">
          <p className="font-display text-sm font-bold text-gold-gradient mb-3" data-id="element-486">
            Sistema de Reprogramación Mental Espiritual™
          </p>
          <p className="text-[#6b6b7b] text-xs leading-relaxed max-w-lg mx-auto mb-4" data-id="element-487">
            Este producto es un recurso educativo digital. Los resultados pueden
            variar según el compromiso y la aplicación individual del protocolo.
            No sustituye asesoría médica o psicológica profesional.
          </p>
          <p className="text-[#6b6b7b] text-xs" data-id="element-488">
            © 2026 SRME™ · Todos los derechos reservados
          </p>
        </div>
      </footer>
    </div>;
}